
// viewport functions
window.viewport = {
    isSmall: false,
    isMedium: false,
    isLarge: false,
    isXLarge: false,
    realHeight: 0
};

function setViewPort(isSmall, isMedium, isLarge, isXLarge) {
    var viewport = window.viewport;
    if (viewport.isSmall != isSmall || viewport.isMedium != isMedium || viewport.isLarge != isLarge || viewport.isXLarge != isXLarge) {
        viewport.isSmall = isSmall;
        viewport.isMedium = isMedium;
        viewport.isLarge = isLarge;
        viewport.isXLarge = isXLarge;

        jQuery(window).trigger('viewportChange', viewport);
    }
}

jQuery(window).on('load resize', function () {
    var viewport = window.viewport;
    var viewportWidth = jQuery(window).width();
    if (viewportWidth <= 479)
        setViewPort(true, false, false, false);
    if (viewportWidth > 479 && viewportWidth <= 768)
        setViewPort(false, true, false, false);
    if (viewportWidth > 768 && viewportWidth <= 1179)
        setViewPort(false, false, true, false);
    if (viewportWidth > 1179)
        setViewPort(false, false, false, true);

    var height = window.innerHeight ? window.innerHeight : jQuery(window).height();
    if (height === viewport.realHeight) {
        viewport.realHeight = height;
        jQuery(window).trigger('viewportHeightChange', viewport);
    }
});
